import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIconBrush = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	xmlSpace: "preserve",
	fillRule: "evenodd",
	strokeLinecap: "round",
	strokeLinejoin: "round",
	clipRule: "evenodd",
	viewBox: "0 0 1024 1024",
	width: "1em",
	height: "1em",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		fill: "none",
		d: "M0 0h1024v1024H0z"
	}), /* @__PURE__ */ _jsx("path", {
		fill: "none",
		stroke: "currentColor",
		strokeWidth: 72.05484,
		d: "M425.832 687.788c-19.528-48.179-66.555-79.814-118.528-79.814-70.18 0-127.908 57.729-127.908 127.908q0 0 0 0c0 52.612-43.319 95.93-95.931 95.93-2.132 0-4.264-.085-6.396-.213 34.194 59.392 97.722 96.145 166.28 96.145 105.269 0 191.863-86.594 191.863-191.862q0 0 0 0c0-17.012-3.326-33.257-9.38-48.094m0 0a682.3 682.3 0 0 0 144.45-69.07m-215.013-1.066c17.268-50.822 40.504-99.385 69.156-144.75M570.24 618.719c80.838-51.078 150.079-118.614 203.118-198.172L938.615 172.66a49.2 49.2 0 0 0 8.314-27.33c0-26.903-22.17-49.074-49.074-49.074-9.721 0-19.229 2.9-27.33 8.314L622.64 269.87a682.4 682.4 0 0 0-198.214 203.075M570.24 618.76c-28.993-64.849-80.966-116.822-145.815-145.815"
	})]
});
export default SvgIconBrush;
